import Vue from 'vue'
import BiddersSearch from '@/widgets/apps/bidit/BiddersSearch.vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'
import moment from 'moment'
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'
import restBidders from '@/plugins/bidit/restBidders'

Vue.filter('formatDate', function(value, type) {
    if (value) {
      return moment(new Date(value)).format(type)
    }
})

Vue.config.productionTip = false

Vue.use(vueCustomElement)
// Vue.use(BootstrapVue)
Vue.use(restBidders)
Vue.customElement('bidders-search', BiddersSearch)
